import React from "react";
import PropTypes from "prop-types";

import { H1, P, Button, Icon } from "orcs-design-system";
import ErrorPageWrapper from "./ErrorPageWrapper";

const UserMessageError = ({ error, showHeader, showContainer }) => {
  const handleActionClick = () => {
    if (error?.actionLink?.path) {
      window.location.href = error.actionLink.path;
    }
  };

  const title = error?.title || "Something went wrong";
  const icon = error?.icon;
  const iconColor = error?.iconColor;
  const wrapperProps = {
    showHeader: showHeader ?? false,
    showContainer,
    showLogoutButton: false,
  };

  // Only pass icon prop if it's defined, otherwise let ErrorPageWrapper use its default
  if (icon) {
    wrapperProps.icon = icon;
  }

  // Only pass iconColor if it's defined
  if (iconColor) {
    wrapperProps.iconColor = iconColor;
  }

  return (
    <ErrorPageWrapper {...wrapperProps}>
      <H1>{title}</H1>
      <P>{error?.message || "An error occurred. Please try again."}</P>
      {error?.actionLink && (
        <Button mt="xs" onClick={handleActionClick} type="button">
          <Icon icon={["fas", "arrow-right"]} />
          {error.actionLink.label}
        </Button>
      )}
    </ErrorPageWrapper>
  );
};

UserMessageError.propTypes = {
  error: PropTypes.shape({
    message: PropTypes.string,
    details: PropTypes.object,
    title: PropTypes.string,
    icon: PropTypes.array,
    iconColor: PropTypes.string,
    actionLink: PropTypes.shape({
      label: PropTypes.string.isRequired,
      path: PropTypes.string.isRequired,
    }),
  }),
  showHeader: PropTypes.bool,
  showContainer: PropTypes.bool,
};

export default UserMessageError;
